import { formatScheduleNotes } from "../../../utils";
import { ListHelper } from "./ListHelper";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface ScheduleNotesSectionProps {
  scheduleNotes: string;
}

export function ScheduleNotesSection(props: ScheduleNotesSectionProps) {
  const { scheduleNotes } = props;
  return (
    <PlacementSectionTemplate title="Additional Information" iconType="info">
      <ListHelper>
        {formatScheduleNotes(scheduleNotes).map((note: string) => (
          <ListHelper.Item key={note}>
            <ListHelper.Text>{note}</ListHelper.Text>
          </ListHelper.Item>
        ))}
      </ListHelper>
    </PlacementSectionTemplate>
  );
}
